// extracted by mini-css-extract-plugin
export default {"root":"ModalBody-module--root--8e93e"};